import { fitFloatingPanel } from '@/utils/floatingPanel';

// Keep row actions reachable inside horizontally scrolling journal tables.
const handlers = new WeakMap();
export default {
	mounted(element) {
		const anchor = element.previousElementSibling;
		const position = () => {
			if (!element.isConnected || !anchor?.isConnected) return;
			const rect = anchor.getBoundingClientRect();
			const width = element.offsetWidth;
			Object.assign(element.style, fitFloatingPanel({ top: rect.top, bottom: rect.bottom, left: rect.right - width }, {
				width, height: element.scrollHeight,
			}));
			element.style.overflowY = 'auto';
		};
		position();
		window.addEventListener('scroll', position, true);
		window.addEventListener('resize', position);
		window.visualViewport?.addEventListener('resize', position);
		window.visualViewport?.addEventListener('scroll', position);
		handlers.set(element, position);
	},
	beforeUnmount(element) {
		const position = handlers.get(element);
		window.removeEventListener('scroll', position, true);
		window.removeEventListener('resize', position);
		window.visualViewport?.removeEventListener('resize', position);
		window.visualViewport?.removeEventListener('scroll', position);
		handlers.delete(element);
	},
};
